module.exports = __webpack_public_path__ + "static/Baggage-second-iteration-3-c69a4584b99201517d4cf7e548d3ccb8.png";